import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {Dealer} from '../../common/actionTypes';

const INITIAL_STATE = {
  'loading': false,
  'dealerInfo': {},
  'orders': [],
  'invoicing': false,
  'agencies': [],
};

export const accessoriesInvoicing = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ORDERS_BY_COMMERCIAL_ORDER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ORDERS_BY_COMMERCIAL_ORDER]: (state, action) => ({
      ...state,
      'loading': false,
      'dealerInfo': action.response.dealerInfo,
      'orders': action.response.data,
    }),
    [ActionTypes.FETCHED_ORDERS_BY_COMMERCIAL_ORDER_FAILED]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [Dealer.FETCHED_AGENCIES_BY_DEALER]: (state, action) => ({
      ...state,
      'agencies': action.response.data,
    }),
    [Dealer.FETCHED_AGENCIES_BY_DEALER_FAILED]: (state, action) => ({
      ...state,
      'agencies': [],
    }),
    [ActionTypes.CREATING_ACCESSORIES_INVOICE]: (state, action) => ({
      ...state,
      'invoicing': true,
    }),
    [ActionTypes.CREATED_ACCESSORIES_INVOICE]: (state, action) => ({
      ...state,
      'invoicing': false,
    }),
    [ActionTypes.CREATED_ACCESSORIES_INVOICE_FAILED]: (state, action) => ({
      ...state,
      'invoicing': false,
    }),
  })(state, action);
};
